import type { PlanEvent } from "../../../shared/types";
import { DAY_START_HOUR, DAY_END_HOUR } from "./time-constants";
import { timeToMinutes } from "./time-positioning";

export interface FreeSlot {
  readonly date: string;
  readonly startTime: string;
  readonly endTime: string;
  readonly durationMinutes: number;
}

function minutesToTime(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function computeFreeSlots(
  events: PlanEvent[],
  date: string,
): FreeSlot[] {
  const dayEvents = events
    .filter((e) => e.date === date && !e.allDay)
    .sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));

  const dayStartMinutes = DAY_START_HOUR * 60;
  const dayEndMinutes = DAY_END_HOUR * 60;

  const slots: FreeSlot[] = [];
  let cursor = dayStartMinutes;

  for (const event of dayEvents) {
    const eventStart = timeToMinutes(event.startTime);
    const eventEnd = timeToMinutes(event.endTime);

    const gapEnd = Math.min(eventStart, dayEndMinutes);
    if (gapEnd - cursor >= 30) {
      slots.push({
        date,
        startTime: minutesToTime(cursor),
        endTime: minutesToTime(gapEnd),
        durationMinutes: gapEnd - cursor,
      });
    }

    cursor = Math.max(cursor, Math.min(eventEnd, dayEndMinutes));
  }

  if (dayEndMinutes - cursor >= 30) {
    slots.push({
      date,
      startTime: minutesToTime(cursor),
      endTime: minutesToTime(dayEndMinutes),
      durationMinutes: dayEndMinutes - cursor,
    });
  }

  return slots;
}
